"use strict";

exports.__esModule = true;
exports.InterpolationTypeSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InterpolationTypeSelector = exports.InterpolationTypeSelector = function InterpolationTypeSelector(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataItem.interpolation.label", "Interpolation Type"),
    helperText: translate("DataItem.interpolation.helperText", "The type of interpolation to show")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    "data-testid": "interpolation-type-selector",
    value: element.props.chartCurve || "stepAfter",
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "chartCurve", e.target.value || undefined);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "stepAfter"
  }, translate("DataItem.interpolation.manhattan.label", "Manhattan")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "linear"
  }, translate("DataItem.interpolation.linear.label", "Linear")))));
};